module.exports = __webpack_public_path__ + "img/3d-painting_cn.b7fa5a6.jpg";